import { Box } from '@mui/material'
import { FC, ReactNode } from 'react'

type LoginBackgroundProps = {
    children: ReactNode
}

export const LoginBackground: FC<LoginBackgroundProps> = ({ children }) => <Box
    component="main"
    sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'url(/static/login/login-bg.svg)',
        backgroundColor: 'background.accent',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    }}
>
    {children}
</Box>
